module.exports = __webpack_public_path__ + "static/img/risk_04_202512.b438eb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/risk/risk_04_202512.jpg
// module id = 3Ff3
// module chunks = 100